const download0 = (data: Blob, fileName: string, mineType: string) => {
  // 创建 blob
  const blob = new Blob([data], { type: mineType })
  // 创建 href 超链接，点击进行下载
  window.URL = window.URL || window.webkitURL
  const href = URL.createObjectURL(blob)
  const downA = document.createElement('a')
  downA.href = href
  downA.download = fileName
  downA.click()
  // 销毁超连接
  window.URL.revokeObjectURL(href)
}

const download = {
  // 下载 Excel 方法
  excel: (data: Blob, fileName: string) => {
    download0(data, fileName, 'application/vnd.ms-excel')
  },
  // 下载 Word 方法
  word: (data: Blob, fileName: string) => {
    download0(data, fileName, 'application/msword')
  },
  // 下载 Zip 方法
  zip: (data: Blob, fileName: string) => {
    download0(data, fileName, 'application/zip')
  },
  // 下载 Html 方法
  html: (data: Blob, fileName: string) => {
    download0(data, fileName, 'text/html')
  },
  // 下载 Markdown 方法
  markdown: (data: Blob, fileName: string) => {
    download0(data, fileName, 'text/markdown')
  }
}

/**
 * 统一的异步下载入口：先拉取 Blob，再立即保存为文件。
 * 供「导出 / 模板下载」场景复用，避免各页面重复写 fetch + 保存逻辑。
 * @param fetcher 返回 Blob 的异步请求（内部已使用 responseType=blob）
 * @param fileName 下载文件名
 * @param type 文件类型，默认 excel
 */
export const downloadFile = async (
  fetcher: () => Promise<Blob>,
  fileName: string,
  type: keyof typeof download = 'excel'
) => {
  const blob = await fetcher()
  download[type](blob, fileName)
  return blob
}

/**
 * 从 Content-Disposition 响应头解析下载文件名
 * 优先取 RFC 5987 的 `filename*=UTF-8''…`（中文名走这支），再兜底 `filename="…"`
 * @param disposition Content-Disposition 头原文
 * @returns 解析出的文件名；无法解析时返回空串
 */
export const parseFileNameFromContentDisposition = (disposition?: string) => {
  if (!disposition) return ''
  const star = /filename\*=\s*UTF-8''([^;]+)/i.exec(disposition)
  if (star) {
    try {
      return decodeURIComponent(star[1].trim())
    } catch {
      // 非法百分号编码：退回下面的 filename= 分支
    }
  }
  const plain = /filename=\s*"?([^";]+)"?/i.exec(disposition)
  return plain ? plain[1].trim() : ''
}

export default download
